import { createFeatureSelector } from '@ngrx/store';

export const menuFlowsState = createFeatureSelector<OLO.State, OLO.State.MenuFlow[]>('menuFlows');
